import { storage } from '@/utils'

let queryArgs = null
const debugKey = 'omWpDebug'

export const enabled = (toDebug = null) => {
	let debugVal = debugKey in queryArgs ? queryArgs.omWpDebug : storage.local.getItem(debugKey)

	if (!debugVal) {
		return false
	}

	if ('1' === debugVal || 'true' === debugVal || true === debugVal) {
		return true
	}

	return toDebug ? toDebug === debugVal : true
}

export const setQueryArgs = (args) => {
	queryArgs = args

	return args
}
